
<div>
    <strong style="font-size:16px;">Welcome</strong>
    <h1 class="user-fullname">{{userName}}</h1>   
</div>



<!-- <div class="container" style="margin-bottom: 230px;" *ngIf="(this.roleId == this.roleAdmin || this.roleId == this.roleSuperAdmin)">
    <h2>Inward Requests</h2>
    <br/>
    <div class="angry-grid">
        <div id="item-0">
            <div class="BoxOne">
                <div class="BoxThree">
                    <span class="Status">Created</span><br/>
                    <span class="StatusNbr" *ngIf="!this.showLoader1">{{this.created}}</span>
                    <img *ngIf="this.showLoader1" src="../../../assets/images/dashboardLoader.gif" style="width:30px;height: 30px;"/>
                </div>
                <div class="BoxFour">
                    <img src="../../../assets/images/dashboardcreated.png"/>
                </div>
            </div>
            <div class="BoxTwo">
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.returnableCreated}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Non Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.nonreturnableCreated}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Internal Movement : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.imcreated}}</span>
                </div>
            </div>
        </div>
        <div id="item-1">
            <div class="BoxOne">
                <div class="BoxThree">
                    <span class="Status">Checked</span><br/>
                    <span class="StatusNbr" *ngIf="!this.showLoader1">{{this.checked}}</span>
                    <img *ngIf="this.showLoader1" src="../../../assets/images/dashboardLoader.gif" style="width:30px;height: 30px;"/>
                </div>
                <div class="BoxFour">
                    <img src="../../../assets/images/dashboardchecked.png"/>
                </div>
            </div>
            <div class="BoxTwo">
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.returnableChecked}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Non Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.nonreturnableChecked}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Internal Movement : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.imchecked}}</span>
                </div>
            </div>
        </div>
        <div id="item-2">
            <div class="BoxOne">
                <div class="BoxThree">
                    <span class="Status">Challan Uploaded</span><br/>
                    <span class="StatusNbr" *ngIf="!this.showLoader1">{{this.challan}}</span>
                    <img *ngIf="this.showLoader1" src="../../../assets/images/dashboardLoader.gif" style="width:30px;height: 30px;"/>
                </div>
                <div class="BoxFour">
                    <img src="../../../assets/images/dashboardchallan.png"/>
                </div>
            </div>
            <div class="BoxTwo">
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.returnableChallan}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Non Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.nonreturnableChallan}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Internal Movement : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.imchallan}}</span>
                </div>
            </div>
        </div>
        <div id="item-3">
            <div class="BoxOne">
                <div class="BoxThree">
                    <span class="Status">Transaction Complete</span><br/>
                    <span class="StatusNbr" *ngIf="!this.showLoader1">{{this.received}}</span>
                    <img *ngIf="this.showLoader1" src="../../../assets/images/dashboardLoader.gif" style="width:30px;height: 30px;"/>
                </div>
                <div class="BoxFour">
                    <img src="../../../assets/images/dashboardreceived.png"/>
                </div>
            </div>
            <div class="BoxTwo">
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.returnableReceived}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Internal Movement : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.imreceived}}</span>
                </div>
            </div>
        </div>
        <div id="item-4">
            <div class="BoxOne">
                <div class="BoxThree">
                    <span class="Status">Declined</span><br/>
                    <span class="StatusNbr" *ngIf="!this.showLoader1">{{this.declined}}</span>
                    <img *ngIf="this.showLoader1" src="../../../assets/images/dashboardLoader.gif" style="width:30px;height: 30px;"/>
                </div>
                <div class="BoxFour">
                    <img src="../../../assets/images/dashboarddeclined.png"/>
                </div>
            </div>
            <div class="BoxTwo">
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.returnableDeclined}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Non Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.nonreturnableDeclined}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Internal Movement : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.imdeclined}}</span>
                </div>
            </div>
        </div>
    </div>

    <br/>
    <h2>Outward Requests</h2>
    <br/>
    <div class="angry-grid2">
        <div id="item-0">
            <div class="BoxOne">
                <div class="BoxThree">
                    <span class="Status">Created</span><br/>
                    <span class="StatusNbr" *ngIf="!this.showLoader2">{{this.ocreated}}</span>
                    <img *ngIf="this.showLoader2" src="../../../assets/images/dashboardLoader.gif" style="width:30px;height: 30px;"/>
                </div>
                <div class="BoxFour">
                    <img src="../../../assets/images/dashboardcreated.png"/>
                </div>
            </div>
            <div class="BoxTwo">
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.oreturnableCreated}}</span>
                </div>
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Internal Movement : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.internalCreated}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Non Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.ononreturnableCreated}}</span>
                </div>
            </div>
        </div>
        <div id="item-1">
            <div class="BoxOne">
                <div class="BoxThree">
                    <span class="Status">LA Approved 1</span><br/>
                    <span class="StatusNbr" *ngIf="!this.showLoader2">{{this.laappr1}}</span>
                    <img *ngIf="this.showLoader2" src="../../../assets/images/dashboardLoader.gif" style="width:30px;height: 30px;"/>
                </div>
                <div class="BoxFour">
                    <img src="../../../assets/images/laapprover.png"/>
                </div>
            </div>
            <div class="BoxTwo">
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.returnablelaappr1}}</span>
                </div>
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Internal Movement : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.internallaappr1}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Non Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.nonreturnablelaappr1}}</span>
                </div>
            </div>
        </div>
        <div id="item-2">
            <div class="BoxOne">
                <div class="BoxThree">
                    <span class="Status">LA Approved 2</span><br/>
                    <span class="StatusNbr" *ngIf="!this.showLoader2">{{this.laappr2}}</span>
                    <img *ngIf="this.showLoader2" src="../../../assets/images/dashboardLoader.gif" style="width:30px;height: 30px;"/>
                </div>
                <div class="BoxFour">
                    <img src="../../../assets/images/laapprover.png"/>
                </div>
            </div>
            <div class="BoxTwo">
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.returnablelaappr2}}</span>
                </div>
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Internal Movement : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.internallaappr2}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Non Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.nonreturnablelaappr2}}</span>
                </div>
            </div>
        </div>
        <div id="item-3">
            <div class="BoxOne">
                <div class="BoxThree">
                    <span class="Status">Supervisor Approved</span><br/>
                    <span class="StatusNbr" *ngIf="!this.showLoader2">{{this.supappr}}</span>
                    <img *ngIf="this.showLoader2" src="../../../assets/images/dashboardLoader.gif" style="width:30px;height: 30px;"/>
                </div>
                <div class="BoxFour">
                    <img src="../../../assets/images/supervisorapproval.png"/>
                </div>
            </div>
            <div class="BoxTwo">
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.returnablesupappr}}</span>
                </div>
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Internal Movement : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.internalsupappr}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Non Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.nonreturnablesupappr}}</span>
                </div>
            </div>
        </div>
        <div id="item-4">
            <div class="BoxOne">
                <div class="BoxThree">
                    <span class="Status">Received</span><br/>
                    <span class="StatusNbr" *ngIf="!this.showLoader2">{{this.oreceived}}</span>
                    <img *ngIf="this.showLoader2" src="../../../assets/images/dashboardLoader.gif" style="width:30px;height: 30px;"/>
                </div>
                <div class="BoxFour">
                    <img src="../../../assets/images/dashboardreceived.png"/>
                </div>
            </div>
            <div class="BoxTwo">
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.oreturnableReceived}}</span>
                </div>
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Internal Movement : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.internalReceived}}</span>
                </div>
            </div>
        </div>
        <div id="item-5">
            <div class="BoxOne">
                <div class="BoxThree">
                    <span class="Status">Declined</span><br/>
                    <span class="StatusNbr" *ngIf="!this.showLoader2">{{this.odeclined}}</span>
                    <img *ngIf="this.showLoader2" src="../../../assets/images/dashboardLoader.gif" style="width:30px;height: 30px;"/>
                </div>
                <div class="BoxFour">
                    <img src="../../../assets/images/dashboarddeclined.png"/>
                </div>
            </div>
            <div class="BoxTwo">
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.oreturnableDeclined}}</span>
                </div>
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Internal Movement : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.internalDeclined}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Non Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.ononreturnableDeclined}}</span>
                </div>
            </div>
        </div>
        <div id="item-6">
            <div class="BoxOne">
                <div class="BoxThree">
                    <span class="Status">Cancelled</span><br/>
                    <span class="StatusNbr" *ngIf="!this.showLoader2">{{this.cancelled}}</span>
                    <img *ngIf="this.showLoader2" src="../../../assets/images/dashboardLoader.gif" style="width:30px;height: 30px;"/>
                </div>
                <div class="BoxFour">
                    <img src="../../../assets/images/dashboarddeclined.png"/>
                </div>
            </div>
            <div class="BoxTwo">
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.returnablecancelled}}</span>
                </div>
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Internal Movement : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.internalcancelled}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Non Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.nonreturnablecancelled}}</span>
                </div>
            </div>
        </div>
        <div id="item-7">
            <div class="BoxOne">
                <div class="BoxThree">
                    <span class="Status">Print Pass</span><br/>
                    <span class="StatusNbr" *ngIf="!this.showLoader2">{{this.printpass}}</span>
                    <img *ngIf="this.showLoader2" src="../../../assets/images/dashboardLoader.gif" style="width:30px;height: 30px;"/>
                </div>
                <div class="BoxFour">
                    <img src="../../../assets/images/printpass.png"/>
                </div>
            </div>
            <div class="BoxTwo">
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.returnableprintpass}}</span>
                </div>
                <div style="flex:1;display: flex;;align-items: center;">
                    <span style="color: #75787B;">Internal Movement : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.internalprintpass}}</span>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <span style="color: #75787B;">Non Returnable : </span>&nbsp;&nbsp;<span style="font-weight: bold;">{{this.nonreturnableprintpass}}</span>
                </div>
            </div>
        </div>
    </div>
</div> -->